<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h4>商店參數</h4>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label">查詢商店</label>
      <div class="col-sm-6">
        <fg-input
          placeholder="Please input account ID"
          v-model="accountId"
          @keyup.enter.native="getData(accountId)"
        ></fg-input>
      </div>
      <div class="col-sm-4">
        <el-button @click.prevent="getData(accountId)">查詢</el-button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card" v-show="isShowAccount()">
          <div class="card-header">
            <h4>account參數</h4>
          </div>
          <div class="card-body">
            <div class="all-icons">
              <div class="row">
                <BoxBoolean
                  :databaseColumnName="'sys_closed'"
                  :data="accountData"
                  :displayColumnName="'系統狀態'"
                  @toggle="accountToggle($event)"
                  revert
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_manual'"
                  :data="accountData"
                  :displayColumnName="'手動接單'"
                  @toggle="accountToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_new_style'"
                  :data="accountData"
                  :displayColumnName="'新版版型'"
                  @toggle="accountToggle($event)"
                ></BoxBoolean>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                {{ accountData }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card" v-show="isShowBusiness()">
          <div class="card-header">
            <h4>business參數</h4>
          </div>
          <div class="card-body">
            <div class="all-icons">
              <div class="row">
                <BoxBoolean
                  :databaseColumnName="'is_eat_in'"
                  :data="businessData"
                  :displayColumnName="'內用'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_to_go'"
                  :data="businessData"
                  :displayColumnName="'外帶'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_delivery'"
                  :data="businessData"
                  :displayColumnName="'外送'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_eat_in_cash'"
                  :data="businessData"
                  :displayColumnName="'內用現金支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_eat_in_pay'"
                  :data="businessData"
                  :displayColumnName="'內用線上支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_to_go_cash'"
                  :data="businessData"
                  :displayColumnName="'外帶現金支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_to_go_pay'"
                  :data="businessData"
                  :displayColumnName="'外帶線上支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_delivery_cash'"
                  :data="businessData"
                  :displayColumnName="'外送現金支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_delivery_pay'"
                  :data="businessData"
                  :displayColumnName="'外送線上支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_mobile_payment'"
                  :data="businessData"
                  :displayColumnName="'線上支付'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_lala'"
                  :data="businessData"
                  :displayColumnName="'lalamove'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_calorie'"
                  :data="businessData"
                  :displayColumnName="'卡路里'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_groupbuy'"
                  :data="businessData"
                  :displayColumnName="'揪團'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_rebuild'"
                  :data="businessData"
                  :displayColumnName="'再點一次'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_pick_up'"
                  :data="businessData"
                  :displayColumnName="'寄杯'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_logistic'"
                  :data="businessData"
                  :displayColumnName="'新版物流'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
                <BoxBoolean
                  :databaseColumnName="'is_auto_restore_stock'"
                  :data="businessData"
                  :displayColumnName="'自動加回庫存'"
                  @toggle="businessToggle($event)"
                ></BoxBoolean>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                {{ businessData }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import {
  getAccountData,
  getBusinessData
} from "src/javascripts/generalPages/fetchData";

import {
  accountToggle,
  businessToggle
} from "src/javascripts/generalPages/updateData";

import BoxBoolean from "./BoxBoolean.vue";

export default {
  components: {
    BoxBoolean
  },
  data() {
    return {
      accountData: {},
      businessData: {},
      accountId: "",
    };
  },
  methods: {
    getData(accountId) {
      let that = this;
      that.accountData = Object.assign({});
      that.businessData = Object.assign({});
      if (accountId) {
        getAccountData(accountId)
          .then(getAccountDataRes => {
            that.accountData = Object.assign({}, getAccountDataRes.data);
          })
          .catch(getAccountDataErr => console.log(getAccountDataErr));

        getBusinessData(accountId)
          .then(getBusinessDataRes => {
            that.businessData = Object.assign({}, getBusinessDataRes.data);
          })
          .catch(getBusinessDataErr => console.log(getBusinessDataErr));
      } else {
        this.$message({
          type: "error",
          message: "Account ID是必填項目"
        });
      }
    },
    accountToggle(d) {
      let key = d.databaseColumnName;
      let label = d.displayColumnName;
      this.accountData[key] = !this.accountData[key];
      this.accountData = Object.assign({}, this.accountData);
      accountToggle(this.accountId, key, this.accountData[key], label)
        .then(accountToggleRes =>
          console.log("accountToggleRes: ", accountToggleRes)
        )
        .catch(accountToggleErr =>
          console.log("accountToggleErr: ", accountToggleErr)
        );
      return;
    },
    businessToggle(key) {
      this.businessData[key] = !this.businessData[key];
      this.businessData = Object.assign({}, this.businessData);
      businessToggle(this.accountId, key, this.businessData[key])
        .then(businessToggleRes =>
          console.log("businessToggleRes: ", businessToggleRes)
        )
        .catch(accountToggleErr =>
          console.log("accountToggleErr: ", accountToggleErr)
        );
      return;
    },
    isShowAccount() {
      return Object.keys(this.accountData).length > 0;
    },
    isShowBusiness() {
      return Object.keys(this.businessData).length > 0;
    }
  }
};
</script>

<style>
.layout-style1 {
  color: rgb(0, 60, 255);
}
.layout-style2 {
  color: rgb(255, 102, 0);
}
.off {
  color: red;
}
.on {
  color: rgb(0, 255, 0);
}

.all-icons .font-icon-detail p {
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-family: fantasy;
}
.top-position-132 {
  top: 132px;
}
.text-red {
  color: red;
}
</style>
